import React from 'react';

interface IChevronDownProps {
	size?: string;
	fill?: string;
	rotate?: boolean;
	large?: boolean;
}

export const ChevronDown = ({ size = '24', fill, rotate = false, large = false }: IChevronDownProps) =>
	large ? (
		<svg
			role="img"
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			className={`${rotate && 'rotate-180'} ease-in-out duration-300`}
			aria-labelledby="chevronDown">
			<title id="chevronDown">chevron down icon</title>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.6464 16.2803L3.64642 8.28035L4.35353 7.57324L12 15.2197L19.6464 7.57324L20.3535 8.28035L12.3535 16.2803C12.1583 16.4756 11.8417 16.4756 11.6464 16.2803Z"
				fill={fill || '#3D3D3D'}
			/>
		</svg>
	) : (
		<svg
			role="img"
			width={size}
			height={size}
			viewBox="0 0 32 32"
			fill="none"
			className={`${rotate && 'rotate-180'} ease-in-out duration-300`}
			aria-labelledby="chevronDown">
			<title id="chevronDown">chevron down icon</title>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.1111 21.8586L8 14.7475L9.41421 13.3333L15.8182 19.7373L22.2222 13.3333L23.6364 14.7475L16.5253 21.8586C16.3378 22.0462 16.0834 22.1515 15.8182 22.1515C15.553 22.1515 15.2986 22.0462 15.1111 21.8586Z"
				fill={fill || '#3D3D3D'}
			/>
		</svg>
	);
